import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { MessageSentiment } from '@/modules/messenger/_modules/message/constants/MessageSentiment';
import { Message } from '@/modules/messenger/_modules/message/models/Message';
import { User } from '@/modules/user/models/User';

export class MessageDetail extends BaseEntityModel {
  id?: number;
  messageId?: number;
  sentiment?: string;
  message?: Relationship<Message> | null;

  constructor(model: Partial<MessageDetail> = {}) {
    super(model);

    this.id = model.id;
    this.messageId = model.messageId;
    this.sentiment = model.sentiment;

    // @ts-ignore
    this.message = Message.mapModelOrNull(model.message);
    // @ts-ignore
    this.user = User.mapModelOrNull(model.user);
  }

  get sentimentEnum(): MessageSentiment | undefined {
    return this.sentiment ? MessageSentiment.getByKey(this.sentiment) : undefined;
  }

  get isPositive(): boolean {
    return this.sentiment === MessageSentiment.POSITIVE.key;
  }

  get isMixed(): boolean {
    return this.sentiment === MessageSentiment.MIXED.key;
  }

  get isNegative(): boolean {
    return this.sentiment === MessageSentiment.NEGATIVE.key;
  }
}
